function calc_container_width(root) {
	let container = document.getElementsByClassName('container')[0];
	root.style.setProperty('--current-container-width', container.clientWidth + 'px');
}

function init() {
	const r = document.querySelector(':root');
	calc_container_width(r);
	addEventListener("resize", (event) => calc_container_width(r));
}

export default {
	init
};
